import { render, staticRenderFns } from "./privacidad.vue?vue&type=template&id=7f20993e"
import script from "./privacidad.vue?vue&type=script&lang=js"
export * from "./privacidad.vue?vue&type=script&lang=js"
import style0 from "./privacidad.vue?vue&type=style&index=0&id=7f20993e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports